import { canViewReportTimestampTab } from '../../../global_context/capabilities/reportCapabilities'
import { ChartBar, ClockAfternoon, GitDiff } from '@phosphor-icons/react'

export const UserReportTabs = {
  route_execution: 1,
  activity_breakdown: 2,
  timestamp_control: 3
}

export const UserReportTabLabels = {
  [UserReportTabs.route_execution]: 'Ejecución de plan de visitas',
  [UserReportTabs.activity_breakdown]: 'Desglose de actividades',
  [UserReportTabs.timestamp_control]: 'Control de horario'
}

export const UserReportTabsMap = {
  route_execution: UserReportTabs.route_execution,
  activity_breakdown: UserReportTabs.activity_breakdown,
  timestamp_control: UserReportTabs.timestamp_control
}

const BASE_USER_TABS = [
  {
    label: 'Ejecución de plan de visitas',
    key: 'route_execution',
    value: 'route_execution',
    icon: GitDiff,
    iconSize: 20,
    filled: true
  },
  {
    label: 'Desglose de actividades',
    key: 'activity_breakdown',
    value: 'activity_breakdown',
    icon: ChartBar,
    iconSize: 20,
    filled: true
  }
]

const TIMESTAMP_CONTROL_TAB = {
  label: 'Control de horario',
  key: 'timestamp_control',
  value: 'timestamp_control',
  icon: ClockAfternoon,
  iconSize: 20,
  filled: true
}

export const getUserTabConfig = () =>
  canViewReportTimestampTab() ? [...BASE_USER_TABS, TIMESTAMP_CONTROL_TAB] : BASE_USER_TABS

export const ROUTE_EXECUTION_STATUS_DIR = {
  pending: 'pendiente',
  visited: 'visitado',
  no_visited: 'no visitado',
  no_location: 'sin geocerca'
}

export const ROUTE_EXECUTION_STATUS_OPTIONS = [
  { name: 'PENDIENTE', value: 'pending' },
  { name: 'VISITADO', value: 'visited' },
  { name: 'NO VISITADO', value: 'no_visited' },
  { name: 'SIN GEOCERCA', value: 'no_location' }
]

export const ACTIVITIES_DIR = {
  order: 'Pedidos',
  quote: 'Cotización',
  check_in_out: 'Check-In/Out',
  refund: 'Devolución',
  charge: 'Cobro',
  delivery: 'Entrega',
  no_visit_report: 'Reporte de visita',
  pos_task_activity: 'Ejecución en PDV',
  settlement: 'Liquidación'
}

export const ACTIVITIES_OPTIONS = [
  { name: 'PEDIDOS', value: 'order' },
  { name: 'COTIZACIÓN', value: 'quote' },
  { name: 'CHECK-IN/OUT', value: 'check_in_out' },
  { name: 'DEVOLUCIÓN', value: 'refund' },
  { name: 'COBRO', value: 'charge' },
  { name: 'ENTREGA', value: 'delivery' },
  { name: 'REPORTE DE VISITA', value: 'no_visit_report' },
  { name: 'EJECUCIÓN EN PDV', value: 'pos_task_activity' },
  { name: 'LIQUIDACIÓN', value: 'settlement' }
]

export const BOOLEAN_OPTIONS = [
  { name: 'SI', value: true },
  { name: 'NO', value: false }
]
